import { createSlice } from '@reduxjs/toolkit';

interface MenuState {
    isMenuOpen: boolean;
}

const initialMenuState: MenuState = {
    isMenuOpen: false,
};

const menuSlice = createSlice({
    name: 'menu',
    initialState: initialMenuState,
    reducers: {
        openMenu(state) {
            state.isMenuOpen = true;
        },
        toggleMenu(state) {
            state.isMenuOpen = !state.isMenuOpen;
        },
        toggleMenuFalse(state) {
            state.isMenuOpen = false;
        },
    },
});
export const { openMenu, toggleMenu, toggleMenuFalse } = menuSlice.actions;
export default menuSlice.reducer;
